
import { useState, useEffect, Fragment } from "react";
import {
    StyleSheet, View, Text
} from "react-native";

import { FONT } from "../../../value/staticValues";
import { PLATFORM_URL } from "../../../value/Url";
import { requests } from "../../../common/RestAPI";

import { CustomTextInput, TextArea } from "../../base/CustomInputText";
import { CustomDropDown, DropdownType } from "../../base/CustomDropdown";
import CustomRadioBtn from "../../base/CustomRadioBtn";

import { ReactComponent as MsgInfoImg } from '../../../img/ico-msg-info-2.svg';

import { useTranslation } from "react-i18next";
import { CustomCircleCheckBox } from "../../base/CustomCheckBox";
import CustomText from "components/base/CustomText";
import { checkFormatAllow, parseLocaleDatetime } from "common/util";


interface ProductOptionData {
    product_option_id: string;
    product_option_name: string;
    product_option_description: string;
    product_option_type_code: string;
    product_option_target_code: string;
}

interface ProductData {
    product_id: string;
}

interface ArgsType {
    license_id: string;
    license_number: string;
    license_name: string;
    purchase_ts: string;
    product: ProductData;
    product_options: ProductOptionData[];
    device_count: number;
    multi_user_count: number;
    multi_monitor_count: number;
    upgrade_support_years: number;
    upgrade_support_expire_ts: string;
    use_expire_dates: number;
    relay_session_count: number;
    license_expire_ts: string;
}

interface LicenseUpdateProps {
    showMessageCb?: Function,
    showLoadingCb?: Function,
    showSlideModalCb?: Function,
    stepIndex: number,
    clickedConfirmYn: boolean,
    resultCb?: Function,
    stepCount: number,
    args?: ArgsType
};

interface Option {
    productOptionId: string;
    optionCount: number;
}

interface UpdateOption {
    product_option_id: string;
    option_count: number;
    delete_yn: boolean;
}

LicenseUpdate.defaultProps = {
    stepIndex: 0,
    clickedConfirmYn: false,
    stepCount: 1,
}

export default function LicenseUpdate(props:LicenseUpdateProps) {
    const { t } = useTranslation();

    const [stepIndex, setStepIndex] = useState(0);
    const [executeUpdateYn, setExecuteUpdateYn] = useState(false);

    const [deviceOption, setDeviceOption] = useState<Option>();
    const [multiUserOption, setMultiUserOption] = useState<Option>();
    const [multiMonitorOption, setMultiMonitorOption] = useState<Option>();
    const [upgradeSupportOption, setUpgradeSupportOption] = useState<Option>();
    const [useExpireOption, setUseExpireOption] = useState<Option>();
    const [acessibilityOption, setAcessibilityOption] = useState<Option>();
    const [productOptions, setProductOptions] = useState<ProductOptionData[]> ([]);
    
    
    useEffect(() => {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        setStepIndex(props.stepIndex);
    }, [props.stepIndex]);


    useEffect(() => {
        if(props.clickedConfirmYn === true) {
            if(stepIndex < props.stepCount - 1) {
                if(stepIndex === 0) {
                    
                }
            } else {
                const successYn = checkLicenseData();
                if(successYn) {
                    setExecuteUpdateYn(true);
                } else {
                    executeResult({successYn: false}, false, '');;
                }
            }
            
        }
    }, [props.clickedConfirmYn]);


    useEffect(() => {
        if(props.args?.license_id) {
            loadProductOptions();
        }
    }, [props.args])


    useEffect(() => {
        if(productOptions) {
            for (let productOption of productOptions) {
                if (productOption.product_option_type_code === "MTDEV") {
                    setDeviceOption({productOptionId: productOption.product_option_id, optionCount: props.args?.device_count || 0});
                } else if(productOption.product_option_type_code === "MTUSR") {
                    setMultiUserOption({productOptionId: productOption.product_option_id, optionCount: props.args?.multi_user_count || 0});
                } else if(productOption.product_option_type_code === "MTMON") {
                    setMultiMonitorOption({productOptionId: productOption.product_option_id, optionCount: props.args?.multi_monitor_count || 0});
                } else if(productOption.product_option_type_code === "UPSPT") {
                    setUpgradeSupportOption({productOptionId: productOption.product_option_id, optionCount: props.args?.upgrade_support_years || 0});
                } else if(productOption.product_option_type_code === "EXPDT") {
                    setUseExpireOption({productOptionId: productOption.product_option_id, optionCount: props.args?.use_expire_dates || 0})
                } else if(productOption.product_option_type_code === "ACBT") {
                    setMultiMonitorOption({productOptionId: productOption.product_option_id, optionCount: props.args?.relay_session_count || 0});
                }
            }
        }
    }, [productOptions])


    useEffect(() => {
        if(executeUpdateYn) {
            executeUpdateLicense();
        }
    }, [executeUpdateYn]);


    function checkLicenseData() {
        let message = "";
        let error = false;
        if(!deviceOption?.optionCount && Number(deviceOption?.optionCount) < 0) {
            message = t("MESSAGE_SERVICE_RDS_LICENSE_OPTION_INFO_ENTER_ERROR_MESSAGE")
            error = true;
        }
        if(!multiUserOption?.optionCount && Number(multiUserOption?.optionCount) < 0) {
            message = t("MESSAGE_SERVICE_RDS_LICENSE_OPTION_INFO_ENTER_ERROR_MESSAGE")
            error = true;
        }
        if(!multiMonitorOption?.optionCount && Number(multiMonitorOption?.optionCount) < 0) {
            message = t("MESSAGE_SERVICE_RDS_LICENSE_OPTION_INFO_ENTER_ERROR_MESSAGE")
            error = true;
        }
        if((!useExpireOption?.optionCount && Number(useExpireOption?.optionCount) < 0) || (!upgradeSupportOption?.optionCount && Number(upgradeSupportOption?.optionCount) < 0)) {
            message = t("MESSAGE_SERVICE_RDS_LICENSE_OPTION_INFO_ENTER_ERROR_MESSAGE")
            error = true;
        }
        if(!acessibilityOption?.optionCount && Number(acessibilityOption?.optionCount) < 0) {
            message = t("MESSAGE_SERVICE_RDS_LICENSE_OPTION_INFO_ENTER_ERROR_MESSAGE")
            error = true;
        }

        if(error === true) {
            executeResult({}, false, message);
        }
        
        return !error;
    }

    function loadProductOptions() {
        requests.get(PLATFORM_URL.PRODUCT + '/' + props.args?.product.product_id + '/options')
        .then((response) => {
            let options: ProductOptionData[] = []
            if (props.args?.product_options) {
                options = [...options, ...props.args?.product_options];
                if (response.status === 200 && response.data) {
                    for (let loadOption of response.data.items) {
                        var existYn = false;
                        for (let propOption of props.args?.product_options) {
                            if (propOption.product_option_type_code === "MTDEV" && loadOption.product_option_type_code === "MTDEV") {
                                existYn = true;
                                break;
                            }
                        }
                        if (existYn === false) {
                            options = [...options, loadOption]
                        }
                    }
                }
            }
            setProductOptions(options);
            
        })
        .catch((error) => {
            
        })
    }

    function executeResult(result, closeYn, infoMessage) {
        setExecuteUpdateYn(false);
        if(props.showMessageCb && infoMessage) {
            props.showMessageCb(infoMessage);
        }
        if(props.resultCb) {
            props.resultCb(result, closeYn);
        }
    }
    function executeUpdateLicense() {
        const updatePackageData = {}

        let options: UpdateOption[] = [];

        if (props.args?.device_count !== deviceOption?.optionCount && deviceOption && deviceOption.optionCount >= 0 && deviceOption?.productOptionId) {
            options = [...options, {product_option_id: deviceOption?.productOptionId, option_count: deviceOption?.optionCount, delete_yn: false}]
        }

        if (props.args?.multi_user_count !== multiUserOption?.optionCount && multiUserOption && multiUserOption.optionCount >= 0 && multiUserOption?.productOptionId) {
            options = [...options, {product_option_id: multiUserOption?.productOptionId, option_count: multiUserOption?.optionCount, delete_yn: false}]
        }

        if (props.args?.multi_monitor_count !== multiMonitorOption?.optionCount && multiMonitorOption && multiMonitorOption.optionCount >= 0 && multiMonitorOption?.productOptionId) {
            options = [...options, {product_option_id: multiMonitorOption?.productOptionId, option_count: multiMonitorOption?.optionCount, delete_yn: false}]
        }
        
        if (props.args?.upgrade_support_years !== upgradeSupportOption?.optionCount && upgradeSupportOption && upgradeSupportOption.optionCount >= 0 && upgradeSupportOption?.productOptionId) {
            options = [...options, {product_option_id: upgradeSupportOption?.productOptionId, option_count: upgradeSupportOption.optionCount, delete_yn: false}]
        }

        if (props.args?.use_expire_dates !== useExpireOption?.optionCount && useExpireOption && useExpireOption.optionCount >= 0 && useExpireOption?.productOptionId) {
            options = [...options, {product_option_id: useExpireOption?.productOptionId, option_count: useExpireOption.optionCount, delete_yn: false}]
        }

        if (props.args?.relay_session_count !== acessibilityOption?.optionCount && acessibilityOption && acessibilityOption.optionCount >= 0 && acessibilityOption?.productOptionId) {
            options = [...options, {product_option_id: acessibilityOption?.productOptionId, option_count: acessibilityOption?.optionCount, delete_yn: false}]
        }
        
        if (options.length === 0) {
            executeResult({successYn: true}, true, "");
            return
        }

        updatePackageData['product_options'] = options;
        
        requests.put(PLATFORM_URL.LICENSE + '/rds/' + props.args?.license_id, updatePackageData)
        .then((response) => {
            console.log(response)
            if(response.status === 200) {
                executeResult({successYn: true }, true, "");
            } else {
                executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
            }
            
        })
        .catch((error) => {
            console.log(error)
            executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
        });
    }
    

    return (
        <View>
            {
                stepIndex === 0 ?
                <View>
                    <View style={style.infoBoxContainer}>
                        <MsgInfoImg/>
                        <Text style={style.infoBoxContainerText}>
                            {t("SERVICE_PRODUCT_UPDATE_INFO_MESSAGE")}
                        </Text>
                    </View>
                    <Text style={style.titleText}>{
                        t("BASE_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("SERVICE_LICENSE_NUMBER_TEXT")}
                            </Text>
                            <Text style={{...style.dataText, color: "#7066f1"}}>
                                {props.args?.license_number}
                            </Text>
                        </View>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("SERVICE_LICENSE_NAME_TEXT")}
                            </Text>
                            <Text style={{...style.dataText, color: "#7066f1"}}>
                                {props.args?.license_name}
                            </Text>
                        </View>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("SERVICE_PURCHASE_DATE_TEXT")}
                            </Text>
                            <Text style={{...style.dataText, color: "#7066f1"}}>
                                {parseLocaleDatetime(props.args?.purchase_ts)}
                            </Text>
                        </View>
                        <View style={style.rowContainer}>
                            <CustomText text={t("SERVICE_LICENSE_DEVICE_COUNT_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomTextInput 
                                key={2} 
                                width={300} height={36} 
                                value={props.args?.device_count + ""}
                                type={"number"} 
                                activeYn={true} 
                                inputCb={(v)=>{setDeviceOption({productOptionId: deviceOption?.productOptionId || "", optionCount: Number(v)})}} 
                                warnYn={false} 
                                placeHolderText={t("0")}
                            />
                        </View>
                        <View style={style.rowContainer}>
                            <CustomText text={t("SERVICE_LICENSE_USER_COUNT_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomTextInput 
                                key={3} 
                                width={300} height={36} 
                                value={props.args?.multi_user_count + ""}
                                type={"number"} 
                                activeYn={true} 
                                inputCb={(v)=>{setMultiUserOption({productOptionId: multiUserOption?.productOptionId || "", optionCount: Number(v)})}} 
                                warnYn={false} 
                                placeHolderText={t("0")}
                            />
                        </View>
                        <View style={style.rowContainer}>
                            <CustomText text={t("SERVICE_LICENSE_MONITOR_COUNT_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomTextInput 
                                key={4} 
                                width={300} height={36} 
                                value={props.args?.multi_monitor_count + ""}
                                type={"number"} 
                                activeYn={true} 
                                inputCb={(v)=>{setMultiMonitorOption({productOptionId: multiMonitorOption?.productOptionId || "", optionCount: Number(v)})}} 
                                warnYn={false} 
                                placeHolderText={t("0")}
                            />
                        </View>
                        <View style={style.rowContainer}>
                            <CustomText text={t("SERVICE_LICENSE_ACESSIBILITY_COUNT_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomTextInput 
                                key={14} 
                                width={300} height={36} 
                                value={props.args?.relay_session_count + ""}
                                type={"number"} 
                                activeYn={true} 
                                inputCb={(v)=>{setAcessibilityOption({productOptionId: acessibilityOption?.productOptionId || "", optionCount: Number(v)})}} 
                                warnYn={false} 
                                placeHolderText={t("0")}
                            />
                        </View>
                        <View style={style.rowContainer}>
                            <CustomText text={t("SERVICE_LICENSE_UPGRADE_SUPPORT_YEARS_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomTextInput 
                                key={5} 
                                width={300} height={36} 
                                value={props.args?.upgrade_support_years + ""}
                                type={"number"} 
                                activeYn={true} 
                                inputCb={(v)=>{setUpgradeSupportOption({productOptionId: upgradeSupportOption?.productOptionId || "", optionCount: Number(v)})}} 
                                warnYn={false} 
                                placeHolderText={t("0")}
                            />
                        </View>
                        <View style={style.rowContainer}>
                            <CustomText text={t("SERVICE_LICENSE_EXPIRE_DATE_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomTextInput 
                                key={6} 
                                width={300} height={36} 
                                value={props.args?.use_expire_dates + ""}
                                type={"number"} 
                                activeYn={true} 
                                inputCb={(v)=>{setUseExpireOption({productOptionId: useExpireOption?.productOptionId || "", optionCount: Number(v)})}} 
                                warnYn={false} 
                                placeHolderText={t("0")}
                            />
                        </View>
                    </View>
                </View>
                : null
            }
        </View>
    )
}


const style = StyleSheet.create({
    titleText: {
        marginTop: 40,
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        fontWeight: "500",
        color: "#0853fb",

    },
    mainContainer: {
        marginTop: 38
    },
    rowContainer: {
        height: 36,
        flexDirection: "row",
        marginBottom: 30,
        alignItems: "center"
    },
    rowTopAlignContainer: {
        minHeight: 36,
        flexDirection: "row",
        marginBottom: 30,
    },
    rowDivContainer: {
        borderStyle: "solid",
        borderBottomWidth: 1,
        borderBottomColor: "#eee",
        marginBottom: 30,
    },
    rowDescribeContainer: {
        marginLeft: 150, marginTop: -10, marginBottom: 40,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 12,
        color: "#8c8c8c"
    },
    columnText: {
        width: 150,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        color: "#333",
    },
    infoBoxContainer: {
        flexDirection: "row", alignItems: "center",
        width: 700, height: 58,
        paddingLeft: 10, paddingRight: 10,
        marginBottom: 15,
        borderRadius: 2,
        backgroundColor: "#fafafa"
    },
    infoBoxContainerText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 18,
        color: "#9ea0a5"
    },
    dataText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333"
    }
});


const labelStyle = {
    fontFamily: FONT.REGULAR,
    fontSize: 12,
    color: "#333"
}